// extracted by mini-css-extract-plugin
export default {"container":"aXOBOn","icon-spacer":"KsMOVs","iconSpacer":"KsMOVs","icon":"ipSfdV","button":"lS0Z88"};